import React from 'react';
import { connect } from 'react-redux';
import { login, updateFormInput, checkAuth, generateValidationCodeForEmail, generateValidationCodeForUsername, loginSubmit } from '../actions/authActions';
import { Grid, Header, Icon, Form, Segment, Button, Message, ButtonOr, ButtonGroup, Divider } from 'semantic-ui-react';
import { DateInput } from 'semantic-ui-calendar-react';
import history from '../history';
import { ROUTES } from '../helpers/routes';

const racer = 3;
const manager = 4;
const racerAndManager = 5;
const parentOfMinor = 6;

class Login extends React.Component {
    state = { showMessage: false, message: '', messageIsInfo: false, messageIsError: false, parentOptionIsSelected: false };

    setAgeIndoramtionMessage = () => {
        const { externalUserType, birthdate } = this.props.auth.registrationForm.fields;

        let birthDateIsSet = false;
        let isUnderEighteen = false;
        if (birthdate) {
            birthDateIsSet = true;
            const inputDate = new Date(birthdate);
            const today = new Date();

            let years = today.getFullYear() - inputDate.getFullYear();
            if (
                today.getMonth() < inputDate.getMonth() ||
                (today.getMonth() === inputDate.getMonth() && today.getDate() < inputDate.getDate())
            ) {
                years--;
            }

            isUnderEighteen = years < 18;
        }

        let message = '';
        let showMessage = false;
        let messageIsInfo = false;
        let messageIsError = false;
        let parentOptionIsSelected = false;
        if (externalUserType === racer) {
            if (birthDateIsSet) {
                if (isUnderEighteen) { // Racer is Selected AND is under 18
                    showMessage = true;
                    messageIsError = true;
                    message = 'Нямате право да създадете самостоятелно профил, ако сте непълнолетен! Нека Вашият родител / настойник Ви регистрира чрез опция "Аз съм Родител / Настойник на непълнолетен Състезател"!';
                } else { // Racer is Selected AND is above 18
                    showMessage = false;
                }
            } else { // Racer is Selected; Date is not Selected
                showMessage = true;
                messageIsInfo = true;
                message = 'Когато сте избрали "Аз съм Състезател" задължително трябва да бъдете пълнолетен!';
            }
        } else if (externalUserType === manager) {
            if (birthDateIsSet) {
                if (isUnderEighteen) { // Manager is Selected AND is under 18
                    showMessage = true;
                    messageIsError = true;
                    message = 'Нямате право да създадете профил тип "Мениджър", ако сте непълнолетен!';
                } else { // Manager is Selected AND is above 18
                    showMessage = false;
                }
            } else {
                showMessage = true;
                messageIsInfo = true;
                message = 'Когато сте избрали "Аз съм Мениджър" задължително трябва да бъдете пълнолетен!';
            }
        } else if (externalUserType === racerAndManager) {
            if (birthDateIsSet) {
                if (isUnderEighteen) { // Racer&Manager is Selected AND is under 18
                    showMessage = true;
                    messageIsError = true;
                    message = 'Нямате право да създадете профил тип "Мениджър", ако сте непълнолетен! Ако желате профил тип "Състезател" нека Вашият родител / настойник Ви регистрира чрез опция "Аз съм Родител / Настойник на непълнолетен Състезател"!';
                } else { // Racer&Manager is Selected AND is above 18
                    showMessage = false;
                }
            } else { // Racer&Manager is Selected; Date is not Selected
                showMessage = true;
                messageIsInfo = true;
                message = 'Когато сте избрали "Аз съм Състезател и Мениджър" задължително трябва да бъдете пълнолетен!';
            }
        } else if (externalUserType === parentOfMinor) {
            parentOptionIsSelected = true;
            if (birthDateIsSet) {
                if (isUnderEighteen) { // ParentOfMinor is Selected AND is under 18
                    showMessage = false;
                } else { // ParentOfMinor is Selected AND is above 18
                    showMessage = true;
                    messageIsError = true;
                    message = 'Когато сте избрали "Аз съм Родител / Настойник на непълнолетен Състезател" задължително вашето дете трябва да бъде не-пълнолетно!';
                }
            } else { // ParentOfMinor is Selected; Date is not Selected
                showMessage = true;
                messageIsInfo = true;
                message = 'Когато сте избрали "Аз съм Родител / Настойник на непълнолетен Състезател" задължително вашето дете трябва да бъде не-пълнолетно!';
            }
        } else {
            if (birthDateIsSet) {
                if (isUnderEighteen) { // User Type not selected AND is under 18
                    showMessage = true;
                    messageIsInfo = true;
                    message = 'Нямате право да създадете самостоятелно профил, ако сте непълнолетен! Само Вашият родител / настойник Ви регистрира чрез опция "Аз съм Родител / Настойник на непълнолетен Състезател"!';
                } else { // User Type not selected; IS above 18
                    showMessage = true;
                    messageIsInfo = true;
                    message = 'Когато сте пълнолетен, може да изберете профил "Аз съм Състезател", "Аз съм Мендиджър" или "Аз съм Състезател и Мендиджър"!';
                }
            } else { // User Type not selected; BirthDate not set
                showMessage = false;
            }
        }

        this.setState({ message: message, showMessage: showMessage, messageIsError: messageIsError, messageIsInfo: messageIsInfo, parentOptionIsSelected: parentOptionIsSelected });
    }

    componentDidMount() {
        this.props.checkAuth();
    }

    onInputChange = async (formName, fieldName, fieldValue) => {
        await this.props.updateFormInput(formName, fieldName, fieldValue);
        this.setAgeIndoramtionMessage();
    }

    onCodeGenerateClickWithEmail = (formName, buttonName, email) => {
        this.props.generateValidationCodeForEmail(formName, buttonName, email);
    }

    onCodeGenerateClickWithUsername = (formName, buttonName, username, password) => {
        this.props.generateValidationCodeForUsername(formName, buttonName, username, password);
    }

    onRegisterClick = () => {
        this.props.loginSubmit('registrationForm', 'submitForm', 'register-external-user')
    }

    onAdministratorLoginClick = () => {
        this.props.loginSubmit('loginForm', 'submitForm', 'login')
    }

    renderErrorMessage = (message) => {
        if (!message) {
            return null;
        }

        return (
            <Message error size='mini' style={{ marginTop: '0px' }}>
                {message}
            </Message>
        );
    }

    renderSuccessMessage = (message) => {
        if (!message) {
            return null;
        }

        return (
            <Message success size='mini' style={{ marginTop: '0px' }}>
                {message}
            </Message>
        );
    }

    renderExternalUserTypeSelector = () => {

        const inactiveOptionProps = { style: { backgroundColor: "#4CC6E4", color: 'white' } };
        const activeOptionProps = { style: { backgroundColor: "#3C8AD9", color: 'white' } };

        let racerProps = inactiveOptionProps;
        let managerProps = inactiveOptionProps;
        let racerAndManagerProps = inactiveOptionProps;
        let parentOfMinorProps = inactiveOptionProps;


        const externalUserType = this.props.auth.registrationForm.fields.externalUserType;
        if (externalUserType === racer) {
            racerProps = activeOptionProps;
        } else if (externalUserType === manager) {
            managerProps = activeOptionProps;
        } else if (externalUserType === racerAndManager) {
            racerAndManagerProps = activeOptionProps;
        } else if (externalUserType === parentOfMinor) {
            parentOfMinorProps = activeOptionProps;
        }

        return (
            <>
                <ButtonGroup style={{ width: '100%' }}>
                    <Button {...racerProps} onClick={() => this.onInputChange('registrationForm', 'externalUserType', racer)}>Аз съм Състезател</Button>
                    <ButtonOr text='|' />
                    <Button {...parentOfMinorProps} onClick={() => this.onInputChange('registrationForm', 'externalUserType', parentOfMinor)}>Аз съм Родител / Настойник на непълнолетен Състезател</Button>
                </ButtonGroup>
                <Divider style={{ marginTop: '2px', marginBottom: '2px', }} />
                <ButtonGroup style={{ width: '100%', marginTop: '1em' }}>
                    <Button {...managerProps} onClick={() => this.onInputChange('registrationForm', 'externalUserType', manager)}>Аз съм Мениджър на Клуб</Button>
                    <ButtonOr text='|' />
                    <Button {...racerAndManagerProps} onClick={() => this.onInputChange('registrationForm', 'externalUserType', racerAndManager)}>Аз съм Състезател и Мениджър</Button>
                </ButtonGroup>
            </>
        );
    }

    renderForms = () => {
        return (
            <Grid centered columns={3} textAlign='center' style={{ marginTop: '0.5em' }}>
                <Grid.Row>
                    <Grid.Column style={{ width: '40%' }}>
                        <Segment raised>
                            <Header as='h4' style={{ color: "#3C8AD9" }} textAlign='center'>
                                <Icon name="user" /> Имам Регистрация
                            </Header>
                            {this.renderErrorMessage(this.props.auth.loginForm.message.errorMessage)}
                            {this.renderSuccessMessage(this.props.auth.loginForm.message.successMessage)}
                            <Form size='tiny'>
                                <Form.Input
                                    label='Имейл / Потребителско Име'
                                    icon='user'
                                    iconPosition='left'
                                    value={this.props.auth.loginForm.fields.username}
                                    onChange={(e) => this.onInputChange('loginForm', 'username', e.target.value)}
                                />

                                <Form.Input
                                    type='password'
                                    fluid
                                    icon='lock'
                                    iconPosition='left'
                                    label='Парола'
                                    value={this.props.auth.loginForm.fields.password}
                                    onChange={(e) => this.onInputChange('loginForm', 'password', e.target.value)}
                                />

                                <Button
                                    loading={this.props.auth.loginForm.buttonIsInAction.generateValidationCode}
                                    disabled={this.props.auth.loginForm.buttonIsInAction.generateValidationCode}
                                    size='tiny'
                                    style={{ backgroundColor: '#3C8AD9', color: 'white' }}
                                    onClick={() => this.onCodeGenerateClickWithUsername(
                                        'loginForm',
                                        'generateValidationCode',
                                        this.props.auth.loginForm.fields.username,
                                        this.props.auth.loginForm.fields.password
                                    )}
                                    fluid
                                    type='submit'
                                >
                                    <Icon name='keyboard'></Icon>
                                    Изпрати ми верификационен код
                                </Button>
                            </Form>
                            <Form size='tiny'>
                                <Form.Input
                                    icon='keyboard'
                                    iconPosition='left'
                                    label='Въведи кода получен по имейл'
                                    value={this.props.auth.loginForm.fields.verificationCode}
                                    onChange={(e) => this.onInputChange('loginForm', 'verificationCode', e.target.value)}
                                />

                                <Button
                                    loading={this.props.auth.loginForm.buttonIsInAction.submitForm}
                                    disabled={this.props.auth.loginForm.buttonIsInAction.submitForm}
                                    style={{ backgroundColor: '#3C8AD9', color: 'white' }}
                                    fluid
                                    size='tiny'
                                    onClick={this.onAdministratorLoginClick}
                                    type='submit'
                                >
                                    Влез
                                </Button>
                            </Form>
                            <Message color='blue' size='mini' onClick={() => history.push(ROUTES.FORGOT_PASSOWRD_ROUTE.URL)} style={{ cursor: 'pointer' }} >
                                Забравена парола? Натисни Тук!
                            </Message>
                        </Segment>
                    </Grid.Column>
                    <Grid.Column style={{ width: '5%' }}>
                        <Header as='h1' style={{ color: "#3C8AD9" }} textAlign='center'>
                            Или
                        </Header>
                    </Grid.Column>
                    <Grid.Column style={{ width: '40%' }}>
                        <Segment raised>
                            <Header as='h4' style={{ color: "#3C8AD9" }} textAlign='center'>
                                <Icon name="user plus" /> Нова Регистрация
                            </Header>
                            {this.renderErrorMessage(this.props.auth.registrationForm.message.errorMessage)}
                            {this.renderSuccessMessage(this.props.auth.registrationForm.message.successMessage)}
                            {this.renderExternalUserTypeSelector()}
                            <Form size='tiny' warning>
                                <Form.Input
                                    action={{
                                        loading: this.props.auth.registrationForm.buttonIsInAction.generateValidationCode,
                                        disabled: this.props.auth.registrationForm.buttonIsInAction.generateValidationCode,
                                        size: 'tiny',
                                        content: 'Изпрати ми верификационен код',
                                        style: { backgroundColor: "#3C8AD9", color: 'white' },
                                        onClick: () => this.onCodeGenerateClickWithEmail('registrationForm', 'generateValidationCode', this.props.auth.registrationForm.fields.email),
                                        icon: 'keyboard',
                                        type: 'submit'
                                    }}
                                    icon='mail'
                                    iconPosition='left'
                                    label={this.state.parentOptionIsSelected ? 'Имейл (Родител / Настойник)' : 'Имейл'}
                                    value={this.props.auth.registrationForm.fields.email}
                                    onChange={(e) => this.onInputChange('registrationForm', 'email', e.target.value)}
                                />
                            </Form>
                            <Form size='tiny'>
                                <Form.Input
                                    icon='keyboard'
                                    iconPosition='left'
                                    label='Въведи кода получен по имейл'
                                    value={this.props.auth.registrationForm.fields.verificationCode}
                                    onChange={(e) => this.onInputChange('registrationForm', 'verificationCode', e.target.value)}
                                />
                                <Form.Input
                                    type='password'
                                    fluid
                                    icon='lock'
                                    iconPosition='left'
                                    label='Парола'
                                    value={this.props.auth.registrationForm.fields.password}
                                    onChange={(e) => this.onInputChange('registrationForm', 'password', e.target.value)}
                                />
                                <Form.Input
                                    type='password'
                                    fluid
                                    icon='lock'
                                    iconPosition='left'
                                    label='Повтори паролата'
                                    value={this.props.auth.registrationForm.fields.confirmPassword}
                                    onChange={(e) => this.onInputChange('registrationForm', 'confirmPassword', e.target.value)}
                                />
                                <Form.Input
                                    as={DateInput}
                                    duration={0}
                                    closable
                                    dateFormat="YYYY-MM-DD"
                                    iconPosition="left"
                                    startMode='year'
                                    initialDate='2003'

                                    fluid
                                    label={this.state.parentOptionIsSelected ? 'Дата на Раждане (Състезател)' : 'Дата на Раждане'}
                                    value={this.props.auth.registrationForm.fields.birthdate}
                                    onChange={
                                        (e, { value }) => {
                                            this.onInputChange('registrationForm', 'birthdate', value);
                                        }
                                    }
                                />
                                <Message
                                    hidden={!this.state.showMessage}
                                    header='Възрастови ограничения'
                                    content={this.state.message}
                                    icon={this.state.messageIsError ? 'warning' : 'info'}
                                    color={this.state.messageIsError ? 'red' : 'teal'}
                                />
                                <Button
                                    loading={this.props.auth.registrationForm.buttonIsInAction.submitForm}
                                    disabled={this.props.auth.registrationForm.buttonIsInAction.submitForm}
                                    style={{ backgroundColor: "#3C8AD9", color: 'white' }}
                                    fluid
                                    size='tiny'
                                    onClick={this.onRegisterClick}
                                    type='submit'
                                >
                                    Регистрирай ме
                                </Button>
                            </Form>
                        </Segment>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }

    render() {
        if (this.props.auth.isLoggedIn) {
            history.push(ROUTES.HOME_SCREEN_ROUTE.URL);
        }

        return (
            <>
                <Header
                    style={{ marginTop: '0.5em', color: "#3C8AD9" }}
                    as='h3'
                    textAlign='center'
                    content='БЪЛГАРСКА ФЕДЕРАЦИЯ ПО МОТОЦИКЛЕТИЗЪМ'
                    subheader='Портал за управление на лицензи (версия за компютър)'
                />
                {this.renderForms()}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return { auth: state.auth };
}

export default connect(mapStateToProps, { login, updateFormInput, checkAuth, generateValidationCodeForEmail, generateValidationCodeForUsername, loginSubmit })(Login);
